'use strict';

module.exports = '3.24.7';



//////////////////
// WEBPACK FOOTER
// ../ui-utilities/node_modules/algoliasearch/src/version.js
// module id = 590
// module chunks = 4